<div [class]="'flex-'+ this.displayType +'-container justify-between py-6 ' + className" [ngClass]="applyBorderBottom ? 'bb-0-5' : ''">
  <div [ngClass]="[keyFs, keyFw, keyClass]">{{ key | translate }}</div>
  <div [ngClass]="[subKeyFs, subKeyFw, subKeyClass]" *ngIf="subKey">{{ subKey | translate }}</div>
  <div [ngClass]="[keyColor, valueFs, valueFw]" class="items-center break-all">
    <div [class.end]="isRow" [ngClass]="descColor" *ngIf="valueKey && value; else plainDescription">
      {{ valueKey + '.' + value | translate }}
    </div>
    <ng-template #plainDescription [ngSwitch]="valueType">
      <div [class.end]="isRow" *ngSwitchDefault [ngClass]="[descColor, pointsBefore ? 'row' : '']" [class]="crossValueClass">
        <span class="row" *ngIf="pointsBefore"> <div *ngFor="let i of arrayOfNumbers(numberOfPoints)">••••&nbsp;</div> </span>{{ value ?
        value : defaultEmptyValue }}
      </div>
      <div [class.end]="isRow" *ngSwitchCase='"percentage"' [ngClass]="descColor" [class]="crossValueClass">{{ value | percent }}</div>
      <div [class.end]="isRow" *ngSwitchCase='"date"' [ngClass]="descColor" [class]="crossValueClass">
        {{ value ? (value | date: DATE_DEFAULT_FORMAT) : defaultEmptyValue }}
      </div>
      <div [class.end]="isRow" *ngSwitchCase='"dateTime"' [ngClass]="descColor" [class]="crossValueClass">
        {{ value ? (value | formatDateTz) : defaultEmptyValue }}
      </div>
      <div [class.end]="isRow" *ngSwitchCase='"currency"' [ngClass]="descColor" [class]="crossValueClass">
        {{ value && !countryCurrency ? (value | currency) : countryCurrency ? (value | currencyFormat) : defaultEmptyValue }}
      </div>
      <div [class.end]="isRow" *ngSwitchCase='"currency-secondary"' [ngClass]="descColor" [class]="crossValueClass">
        {{ value && !countryCurrency ? (value | currency) : countryCurrency ? (value | currencyFormat: 'secondary') : defaultEmptyValue }}
      </div>
      <div *ngSwitchCase='"icon"' [ngClass]="descColor" [class]="crossValueClass">
        <mat-icon *ngIf="icon">{{icon}}</mat-icon>
      </div>
      <div
        *ngSwitchCase='"iconText"'
        [ngClass]="descColor"
        class="flex-row-container justify-between items-center"
        [class]="crossValueClass">
        <span> {{ value ? value : defaultEmptyValue }} </span>
        <mat-icon *ngIf="icon" class="ml-4">{{icon}}</mat-icon>
      </div>
      <div *ngSwitchCase='"link"' [class]="crossValueClass">
        <a [href]="url" target="_blank" class="primary" [ngClass]="descColor">{{value}}</a>
      </div>
      <div *ngSwitchCase='"status"' [ngClass]="descColor" class="flex-row-container justify-between items-center" [class]="crossValueClass">
        <span [ngClass]="STATUS_MAPPER_CLASS(value)"> {{ value ? value : defaultEmptyValue }} </span>
      </div>
      <div
        *ngSwitchCase='"statusIcon"'
        [ngClass]="STATUS_MAPPER_CLASS(value)"
        class="flex-row-container justify-between items-center"
        [class]="crossValueClass">
        <span> {{ value ? value : defaultEmptyValue }} </span>
        <mat-icon fontSet="material-icons-outlined" class="ml-4">{{STATUS_MAPPER_CLASS(value)}}</mat-icon>
        <!-- <span [appStatus]="value"> {{ value ? value : defaultEmptyValue }} </span> -->
      </div>
      <div *ngSwitchCase='"boolean"' [class]="crossValueClass" [ngClass]="descColor">
        <span [ngClass]="BOOLEAN_MAPPER_CLASS(value)"> {{ value && value === true ? ("GLOBAL.YES" | translate)  : ("GLOBAL.NO" | translate)  }} </span>
      </div>
      <div *ngSwitchCase='"img"' [ngClass]="descColor" class="flex-row-container justify-between items-center" [class]="crossValueClass">
        <img [src]="value" alt="image" />
      </div>
      <div *ngSwitchCase='"check"' [class]="crossValueClass">
        <input type="checkbox" class="primary" [ngClass]="descColor" [checked]="value" disabled style="transform: scale(1.5);"/>
      </div>
      <ng-container *ngSwitchCase='"content"'>
        <ng-content></ng-content>
      </ng-container>
    </ng-template>
  </div>
</div>
